import PlantUmlEncoder from 'plantuml-encoder';

import { UmlApiUrl } from 'core/constants/api-urls';

export const getUmlUrl = (code: string) => `${UmlApiUrl}/${PlantUmlEncoder.encode(code)}`;
